import { create } from 'zustand';
import { World } from '../models/World';

interface SimStore {
  world: World;
  isPaused: boolean;
  setPaused: (paused: boolean) => void;
  addCreature: (dna: string) => void;
  spawnFood: (type: 'plant' | 'meat') => void;
}

const world = new World(window.innerWidth, window.innerHeight, 1); // Start with 1 creature

export const useSimStore = create<SimStore>((set, get) => ({
  world,
  isPaused: false,
  setPaused: (paused) => set({ isPaused: paused }),
  addCreature: (dna) => {
    const { world } = get();
    world.addCreature(dna);
  },
  spawnFood: (type) => {
    const { world } = get();
    const position = {
      x: Math.random() * world.getState().width, // Get width from world state
      y: Math.random() * world.getState().height // Get height from world state
    };
    // The 'placeFood' method in World.ts has signature: 
    // placeFood(position: Position, type: Food['type'] = 'plant', size: number = 1, energy: number = 20)
    // We can use default size and energy.
    world.placeFood(position, type); 
  }
})); 